import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { SearchCard } from '../../../search-results/results-card';
import styles from './legal_term_snippet.module.scss';

type Props = {
  handleClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  href: string | undefined;
  text: string;
};

type State = {
  open: boolean;
};

export class LegalTermIndemnity extends React.Component<Props, State> {
  state: State = {
    open: false,
  };

  fullIndemnityFicheClicked = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  render() {
    const { text, href, handleClick } = this.props;
    const { open } = this.state;

    return (
      <SearchCard>
        <div
          className={classNames('search_card__block__fiche', {
            'search_card__block__fiche--full': open,
          })}
        >
          <span dangerouslySetInnerHTML={{ __html: text }} />
          <Hyperlink target="_blank" href={href} onClick={handleClick}>
            {' '}
            <FormattedMessage id="search/components/search-snippets/main/legal-term/LegalTermIndemnity.tsx/1" />
          </Hyperlink>
        </div>
        <div className={styles.seeMore}>
          <button
            type="button"
            className={styles.button}
            onClick={this.fullIndemnityFicheClicked}
          >
            {open ? `Réduire` : `Afficher la suite`}
            <i
              className={classNames(
                'material-icons',
                open ? 'icon__keyboard_arrow_up' : 'icon__keyboard_arrow_down',
              )}
            />
          </button>
        </div>
      </SearchCard>
    );
  }
}
